(function($){
    'use strict';

    var $dismiss = $('[data-dismiss]'),
        dismiss = function() {
            var $this = $(this);
            $this.parents('.flash').hide(200);
        };

    $dismiss.on('click', dismiss);

}(jQuery));
